/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to connect to server`)
};

const zh_hans1_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法连接到服务器`)
};

const zh_hant1_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法連線到伺服器`)
};

const fr_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de se connecter au serveur`)
};

const de_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum Server fehlgeschlagen`)
};

const ja_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーに接続できませんでした`)
};

const ko_settings_error_failed_connect_server = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서버에 연결하지 못했습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_failed_connect_server = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_failed_connect_server(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_failed_connect_server", locale)
	if (locale === "en") return en_settings_error_failed_connect_server(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_failed_connect_server(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_failed_connect_server(inputs)
	if (locale === "fr") return fr_settings_error_failed_connect_server(inputs)
	if (locale === "de") return de_settings_error_failed_connect_server(inputs)
	if (locale === "ja") return ja_settings_error_failed_connect_server(inputs)
	return ko_settings_error_failed_connect_server(inputs)
};